import { NSModal } from 'bricks';

export interface ISofrRefreshConfirmationModalProps {
    isOpen: boolean;
    toggle: () => void;
    onConfirm: () => void;
}

const SofrRefreshConfirmationModal = ({ isOpen, toggle, onConfirm }: ISofrRefreshConfirmationModalProps) => (
    <NSModal
        isOpen={isOpen}
        toggle={toggle}
        modalHeaderText="Replace with today's SOFR curve?"
        modalHeaderClassName="text-white bg-primary"
        modalFooterButtonText="Update"
        modalFooterButtonFunction={onConfirm}
        modalFooterCancelButtonText="Cancel"
    >
        <div className="text-white">
            This will replace the Term SOFR (1M) row with today's CME forward curve. 
            Any per-period customizations you've made to the base rate will be lost. Your spread values and per-period spread overrides will be kept.
        </div>
    </NSModal>
);

export default SofrRefreshConfirmationModal;
